import { usePage } from "@inertiajs/react";

const KinescopeLayout = ({
  layout,
}) => {
  const { is_mobile } = usePage().props;

  return (
    <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
      <div id={`kinescope-${layout.id}`}></div>
    </div>
  );
};

export default KinescopeLayout;
